import React, { useRef } from "react";


function Gallery() {
	const rowRef = useRef(null);

	const scrollGallery = (direction) => {
		const row = rowRef.current;
		if (!row) return;
		const scrollAmount = 260; // width of one image + margin
		row.scrollBy({
			left: direction === 'right' ? scrollAmount : -scrollAmount,
			behavior: 'smooth',
		});
	};

	return (
		<section id="gallery" className="gallery">
			<h2>Gallery</h2>
			<div className="gallery-scroll-controls">
				<button className="gallery-scroll-btn left" onClick={() => scrollGallery('left')} aria-label="Scroll left">&#8592;</button>
				<div className="gallery-row" ref={rowRef}>
						<div className="gallery-item">
							<img src={require('../assets/Smiling Patient.jpg')} alt="Smiling Patient" />
							<div className="gallery-caption">Smiling Patient</div>
						</div>
						<div className="gallery-item">
							<img src={require('../assets/Treatment Room.jpg')} alt="Treatment Room" />
							<div className="gallery-caption">Treatment Room</div>
						</div>
						<div className="gallery-item">
							<img src={require('../assets/pexels-cedric-fauntleroy-4269365.jpg')} alt="Dentist at Work" />
							<div className="gallery-caption">Dentist at Work</div>
						</div>
						<div className="gallery-item">
							<img src={require('../assets/pexels-cottonbro-6502544.jpg')} alt="Dental Consultation" />
							<div className="gallery-caption">Dental Consultation</div>
						</div>
						<div className="gallery-item">
							<img src={require('../assets/pexels-cottonbro-6529219.jpg')} alt="Dental Equipment" />
							<div className="gallery-caption">Dental Equipment</div>
						</div>
						<div className="gallery-item">
							<img src={require('../assets/pexels-pavel-danilyuk-6812508.jpg')} alt="Patient Care" />
							<div className="gallery-caption">Patient Care</div>
						</div>
						<div className="gallery-item">
							<img src={require('../assets/pexels-shvetsa-3845729.jpg')} alt="Dental Team" />
							<div className="gallery-caption">Dental Team</div>
						</div>
					{/* Add more <div className="gallery-item">...</div> here for more images */}
				</div>
				<button className="gallery-scroll-btn right" onClick={() => scrollGallery('right')} aria-label="Scroll right">&#8594;</button>
			</div>
		</section>
	);
}


export default Gallery;